import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import TopHeader from '../../components/layouts/TopHeader';
import Button from '../../components/ui/Button';
import CustomInput from '../../components/ui/CustomInput';
import CustomPhoneInput from '../../components/ui/CustomPhoneInput';
import CustomReactSelect from '../../components/ui/CustomReactSelect';
import { ApiConstants } from '../../constants/ApiConstants';
import { PERMISSIONS } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import { checkPermission } from '../../utils/Helper';
import PageLayout from '../../components/ui/PageLayout';
import InviteHouseHoldValidation from '../../validations/household/invitehousehold';
import PageLoader from '../../components/layouts/PageLoader';
import { useDebounce } from "use-debounce";
import CustomRadioWithTooltip from '../../components/ui/CustomRadioWithTooltip';
import UpgradeToast from '../../components/layouts/UpgradeToast';

interface householdInputs {
    name: string;
    email: string,
    household_id: string,
    member_type: string,
    phone_number: string,
    phone_country_code: string,
    income: string,
    monthly_work_hour: string,
    send_invite: boolean,
};




const AddInvite = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const member = location.state?.member;
    console.log("member", member)
    const profile: any = useContext(authContext);
    const getHhData = useMakeRequest();
    const hhInvite = useMakeRequest();
    const _isUserExist = useMakeRequest();
    const [sendInviteStatus, setInviteStatus] = useState(true);
    const [isUserExist, setIsUserExist] = useState(false);
    console.log("isUserExist: ", isUserExist)
    const { register, watch, setValue, formState: { errors }, handleSubmit, trigger, reset } = useForm<householdInputs>({
        mode: 'onChange', resolver: yupResolver(InviteHouseHoldValidation)
    });

    const handlePhoneNumber = (value: any, code: any,) => {
        const regex = new RegExp(code?.dialCode);
        const phone = value.replace(regex, "");
        setValue('phone_country_code', code?.dialCode);
        setValue('phone_number', phone);
        trigger("phone_number");
        // setValue('phone_country_code', code?.dialCode);
        // setValue('phone_number', phone);
        // trigger("phone_number")
    }


    const handleSelectChange = (selectedOption: any) => {
        setValue("household_id", selectedOption ? selectedOption.value : "");
        trigger("household_id")
    };


    const memberType = [
        { value: '1', label: 'Partner' },
        { value: '2', label: 'Roommate' },
        { value: '3', label: 'Family member' },
    ];


    const handleSelectMemberType = (selectedOption: any) => {
        trigger("income");
        trigger("monthly_work_hour");
        setValue("member_type", selectedOption ? selectedOption.value : "");
        trigger("member_type");

    };

    useEffect(() => {
        getHhData.makeRequest({ url: ApiConstants?.GetHousehold, payload: { show_all: true } })
        setValue('send_invite', sendInviteStatus)
    }, [])

    const onSubmit = (payload: any) => {
        console.log("calll")
        const pLoad = member ? { ...payload, member_id: member?.user?.id, income: payload?.income ? payload.income.replace(/,/g, '') : '', } : { ...payload, income: payload?.income ? payload.income.replace(/,/g, '') : '', }
        console.log("pLoad: ", pLoad)
        toast.promise(
            hhInvite.makeRequest({ url: member ? ApiConstants?.updateMemberHousehold : ApiConstants?.inviteHousehold, payload: pLoad }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }



    const email = watch("email");
    const [debouncedEmail] = useDebounce(email, 1000);

    useEffect(() => {
        if (member) return;
        console.log("debouncedEmail: ", debouncedEmail)
        if (debouncedEmail) {
            checkIsUserExist(debouncedEmail);
        } else {
            setIsUserExist(false)
            setValue("name", "");
            setValue("member_type", "");
            setValue('income', '');
            setValue("monthly_work_hour", "");
            setValue("phone_country_code", "");
            setValue("phone_number", "");
        }
    }, [debouncedEmail]);

    const checkIsUserExist = (email: string) => {

        if (!email) return;

        _isUserExist.makeRequest({
            url: ApiConstants?.isCurrentUserExist,
            payload: { email }
        }).then((res) => {
            console.log("res: ", res)
            if (res?.data?.isUserExists) {
                setIsUserExist(res?.data?.isUserExists)
                // const user = res?.data?.user
                // setValue("name", user?.name);
                // setValue("member_type", user?.member_type.toString());
                // setValue(
                //     'income',
                //     user?.income
                //         ? Number(user?.income).toLocaleString('en-US')
                //         : ''
                // );
                // setValue("monthly_work_hour", user?.monthly_work_hour);
                // user?.email && setValue("email", user?.email);
                // user?.phone_country_code && setValue("phone_country_code", user?.phone_country_code);
                // user?.phone_number && setValue("phone_number", user?.phone_number);
                // trigger('email');
                // trigger('phone_number');
                // trigger('member_type');
                // trigger('monthly_work_hour');
                // trigger('income');
                // trigger('household_id')
                // trigger('name');
            } else {
                setIsUserExist(false)
            }
        })
    };

    const handleInviteStatusChange = (status: boolean) => {
        if (profile?.data?.is_free_plan || checkPermission(profile?.data?.plan_perms, PERMISSIONS?.ALLOW_INVITE)) {
            const newStatus = status;
            setIsUserExist(false)
            if (!member) {
                setValue("email", "");
                setValue("name", "");
                setValue("member_type", "");
                setValue('income', '');
                setValue("monthly_work_hour", "");
                setValue("phone_country_code", "");
                setValue("phone_number", "");
            }
            setValue('send_invite', newStatus);
            setInviteStatus(newStatus);
            trigger('email');
        } else {
            toast.dismiss();
            toast.custom((t) => <UpgradeToast t={t} />, {
                id: "upgrade-toast",
                duration: 3000,
            });
        }
    }

    useEffect(() => {
        if (hhInvite?.data) {
            navigate(Routes?.ManageHousehold)
            reset();
        }
    }, [hhInvite?.data])

    useEffect(() => {
        if (getHhData?.status) {
            setValue("household_id", getHhData?.data?.data?.[0]?.value);
        }
    }, [getHhData?.data])

    useEffect(() => {
        if (member) {
            setValue("name", member?.user?.name);
            setValue("member_type", member?.member_type.toString());
            setValue(
                'income',
                member?.user?.income
                    ? Number(member?.user?.income).toLocaleString('en-US')
                    : ''
            );
            setValue("monthly_work_hour", member?.user?.monthly_work_hour);
            member?.user?.email && setValue("email", member?.user?.email);
            member?.user?.phone_country_code && setValue("phone_country_code", member?.user?.phone_country_code);
            member?.user?.phone_number && setValue("phone_number", member?.user?.phone_number);
            const isTemp = !!member?.user?.is_temp_user;
            setInviteStatus(!isTemp);
            setValue('send_invite', !isTemp);
        }
    }, [member])


    return (
        <PageLayout headerName={member ? 'Edit Member' : 'Add/Invite Household Members'} onlyTitle={false}>
            {profile?.loading ? <PageLoader /> : ''}
            <form onSubmit={handleSubmit(onSubmit)} className='page-padding-x'>
                <div className="auth-form">
                    <>
                        <div className="auth-form-fields mb-3">
                            {!member && (
                                <div className='radio-group-wrap mb-3 d-flex flex-column gap-2 mb-4'>
                                    <CustomRadioWithTooltip
                                        id="proxy-member"
                                        name="inviteType"
                                        value="proxy"
                                        label="Create proxy member"
                                        tooltipText="Proxy members are completely managed through your account. You can edit their information and manage their chores, expenses, contributions, opportunity costs, and payments. Later, you can opt to invite this member to establish their own user account."
                                        checked={!sendInviteStatus}
                                        onChange={(val) => handleInviteStatusChange(val === 'invite')}
                                    />
                                    <CustomRadioWithTooltip
                                        id="invite-member"
                                        name="inviteType"
                                        value="invite"
                                        label="Invite member"
                                        tooltipText="If the invited member accepts the invite, they will manage their own user account, including their chores, expenses, contributions, opportunity costs, and payments."
                                        checked={sendInviteStatus}
                                        onChange={(val) => handleInviteStatusChange(val === 'invite')}
                                    />
                                </div>
                            )}


                            <CustomReactSelect
                                label="Household Name"
                                value={{ value: getHhData?.data?.data?.[0]?.value, label: getHhData?.data?.data?.[0]?.label }}
                                options={getHhData?.data?.data}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                placeholder="Please select household name"
                                onChange={handleSelectChange}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                                isLoading={getHhData?.loading}
                                error={errors}
                                errorName='household_id'
                            />
                            <CustomInput
                                label="Name"
                                type="text"
                                placeholder="Enter name"
                                required
                                {...register('name')}
                                error={errors.name?.message}
                            />

                            <CustomReactSelect
                                label='Member Type'
                                options={memberType}
                                className="com-r-select"
                                classNamePrefix="com-r-select"
                                placeholder="Please select member type"
                                value={memberType?.find((option: any) => option.value === watch('member_type'))}
                                onChange={handleSelectMemberType}
                                closeMenuOnScroll={true}
                                closeMenuOnSelect={true}
                                error={errors}
                                errorName='member_type'
                            />

                            <CustomInput
                                label="Income"
                                placeholder='$00.00'
                                tooltip={{
                                    content: "income",
                                    id: "income",
                                    place: "bottom"
                                }}
                                {...register('income')}
                                onInput={(e: any) => {
                                    let value = e.target.value;

                                    // remove commas first
                                    value = value.replace(/,/g, '');

                                    // allow only numbers and decimal
                                    value = value.replace(/[^0-9.]/g, '');

                                    // allow only one decimal
                                    const decimalCount = value.split('.').length - 1;
                                    if (decimalCount > 1) {
                                        const parts = value.split('.');
                                        value = parts[0] + '.' + parts.slice(1).join('');
                                    }

                                    let parts = value.split('.');

                                    // limit integer length
                                    if (parts[0].length > 7) {
                                        parts[0] = parts[0].substring(0, 7);
                                    }

                                    // limit decimal to 2
                                    if (parts[1]) {
                                        parts[1] = parts[1].substring(0, 2);
                                    }

                                    // add commas to integer part
                                    parts[0] = Number(parts[0]).toLocaleString('en-US');

                                    e.target.value = parts.join('.');
                                }}
                                error={errors.income?.message}
                            />

                            <CustomInput
                                label="Hours of Employment (Monthly)"
                                placeholder="Enter hours"
                                tooltip={{
                                    content: "Hours of Employment",
                                    id: "hours_of_employment",
                                    place: "bottom"
                                }}
                                {...register('monthly_work_hour')}
                                onInput={(e: any) => {
                                    let value = e.target.value;

                                    // Remove non-digits
                                    value = value.replace(/\D/g, "");

                                    // Prevent multiple leading zeros
                                    if (value === "00" || value === "000") {
                                        value = "0";
                                    }

                                    // If starts with 0 and has more digits, remove leading zero
                                    if (value.length > 1 && value.startsWith("0")) {
                                        value = value.replace(/^0+/, "");
                                    }

                                    // Limit to 3 digits
                                    if (value.length > 3) {
                                        value = value.slice(0, 3);
                                    }

                                    // Cap max value to 720
                                    if (Number(value) > 720) {
                                        value = "720";
                                    }

                                    e.target.value = value;
                                }}
                                error={errors.monthly_work_hour?.message}
                            />

                            {
                                sendInviteStatus && (
                                    <>
                                        <CustomInput
                                            label="Email"
                                            type="email"
                                            placeholder="Enter email"
                                            required
                                            {...register('email')}
                                            error={errors.email?.message}
                                        />


                                        <CustomPhoneInput
                                            label="Mobile Number"
                                            value={`${watch('phone_country_code') || ''}${watch('phone_number') || ''}`}
                                            onChange={handlePhoneNumber}
                                            error={errors.phone_number?.message}
                                            defaultCountry="us"
                                            placeholder="+1 (555) 000-0000"
                                        />

                                    </>
                                )
                            }

                        </div>
                        <Button className='com-btn my-5' type="submit" text="submit" loading={hhInvite?.loading}>{member ? 'Update' : 'Continue'}</Button>
                    </>
                </div>
            </form>
        </PageLayout>
    )

}

export default AddInvite
